import styled from 'styled-components';

export const Container = styled.div`
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(5px);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;

  @media screen and (max-width: 768px) {
    padding: 20px;
  }
`;

export const Content = styled.div`
  position: relative;
  background-color: #fff;
  border-radius: 15px;
  width: 646px;
  border: 6.58px solid rgba(255, 255, 255, 0.3);
  box-shadow: 4px 4px 44px rgba(0, 0, 0, 0.06);
  padding: 40px;

  @media screen and (max-width: 768px) {
    width: 100%;
    max-height: 70vh;
    overflow-y: auto;
    padding: 20px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const Title = styled.p`
  font-weight: 500;
  line-height: 1.2;
  color: #333333;
  font-size: 3rem;

  @media screen and (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const Text = styled.p`
  font-family: 'Graphik', sans-serif;
  font-weight: 400;
  font-size: 1.188rem;
  line-height: 26px;
  color: #888888;
  text-align: left;
  margin-bottom: 16px;

  @media screen and (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

export const CloseButton = styled.button`
  cursor: pointer;
  margin-top: 24px;
  padding: 10px 24px;
  background-color: #d8f32e;
  color: #333333;
  border: none;
  border-radius: 8px;
  font-family: 'Graphik', sans-serif;
  font-weight: 500;
  font-size: 1rem;

  &:hover {
    opacity: 0.9;
  }
`;